import { useI18n } from "@/context/I18nContext";
import useSiteSettings from "@/hooks/useSiteSettings";

/**
 * Ticker banner shown above the header. Text and speed are editable from
 * Settings admin. When disabled the component renders nothing so downstream
 * layout stays clean.
 */
export default function NotificationBanner() {
    const { t, lang } = useI18n();
    const { settings } = useSiteSettings();
    const cfg = settings.banner || {};
    if (cfg.enabled === false) return null;

    const es = lang === "es";
    const phrase = (es ? cfg.text_es : cfg.text_en)
        || `🔥  ${t("banner")}  ·  $9.75 Chimi Special  ·  Free pickup at 405 Foxon Blvd  ·  📞 (203) 466-6226  ·  ⭐ 5.0 rated`;
    const speed = Number(cfg.speed_seconds) > 0 ? Number(cfg.speed_seconds) : 30;

    return (
        <div
            data-testid="notification-banner"
            className="bg-secondary text-secondary-foreground py-2 overflow-hidden whitespace-nowrap text-xs sm:text-sm font-bold uppercase tracking-[0.2em]"
        >
            <div className="ticker" style={{ animationDuration: `${speed}s` }}>
                <span className="px-4">{phrase}</span>
                <span className="px-4">{phrase}</span>
                <span className="px-4">{phrase}</span>
                <span className="px-4">{phrase}</span>
            </div>
        </div>
    );
}
